export default {
  SET_DISCIPLINARY_SETTINGS: (state, payload) => {
    state.disciplinarySettings = payload
  },
  SET_PAYMENT_SETTINGS: (state, payload) => {
    state.paymentSettings = payload
  }
}
